import { DataService } from './../../../../../services/data.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../../../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../../../../services/common-authentication.service';
import { NotificationService } from './../../../../../services/notification.service';
import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';




@Component({
  selector: 'app-student-rotc-panel',
  templateUrl: './student-rotc-panel.component.html',
  styleUrls: ['./student-rotc-panel.component.scss']
})
export class StudentRotcPanelComponent implements OnChanges, OnDestroy {
  @Input() profileData: any;

  ROTCListJson = [];
  selectedROTCList = [];
  rotcJson: any;
  rotcFormTouched = false;
  private destroyed$ = new Subject();

  constructor(
    private notificationService: NotificationService,
    private _commonAuthService: CommonAuthenticationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private commonDataSharedService: CommonDataSharedService,
    private dataService: DataService
  ) {
    this.getROTCList();
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.rotcFormTouched = false;
    this.ROTCListJson = [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['profileData'] !== undefined && changes['profileData'].currentValue !== undefined) {
      this.setRotcValue(changes['profileData'].currentValue || {});
    }
  }

  getROTCList() {
    this.ROTCListJson = this.dataService.getEntity('ROTC').item || [];
  }

  getROTCData() {
    this.selectedROTCList = [];

    for (let i = 0; i < this.ROTCListJson.length; i++) {
      if (this.ROTCListJson[i].checked) {
        this.selectedROTCList.push(this.ROTCListJson[i].id);
      }
    }
    this.commonDataSharedService.studentQuestionaryThreeROTCData.next({ selectedList: this.selectedROTCList });
  }

  setRotcValue(detailData) {
    if (detailData) {
      this.rotcJson = detailData;
      if (this.ROTCListJson && this.ROTCListJson.length > 0 && this.rotcJson && this.rotcJson.rotcClassIds && this.rotcJson.rotcClassIds.length > 0) {
        for (let i = 0; i < this.ROTCListJson.length; i++) {
          const id = this.ROTCListJson[i].id + '';
          if (this.rotcJson.rotcClassIds.indexOf(id) > -1) {
            this.ROTCListJson[i]['checked'] = true;
            this.selectedROTCList.push(id);
          }
        }
      }
      const rotcObje = { selectedList: this.selectedROTCList };
      this.commonDataSharedService.studentQuestionaryThreeROTCData.next(rotcObje);
    }
  }

  changeRotc(club: any) {
    this.rotcFormTouched = true;
    if (club.text === 'Unsure') {
      this.ROTCListJson.forEach((c) => {
        if (c.text !== 'Unsure') {
          c.checked = false
        }
      })
      club.checked = !club.checked;
      return;
    }
    const unsureCheckbox = this.ROTCListJson.find(c => c.text === 'Unsure');
    if (unsureCheckbox) {
      unsureCheckbox.checked = false;
    }
    club.checked = !club.checked;
  }
}
